import AppContainer from "../../components/AppContainer";
import Footer from "../../components/Footer/Footer";
import { localLegalInfo } from "../../components/utils/local.policy";
import { getStore } from "../../services/backend/serverSideProps";

export async function getServerSideProps(context) {
  return getStore(context);
}

const Returns = (props) => {
  const { storeData, themeData } = props;

  let returns = storeData?.legalInfo?.returns || localLegalInfo.returns || "";
  returns = returns.replace("{{dispatch time}}", storeData.dispatchTime);

  return (
    <AppContainer>
      <main>
        <h2 className="sidepage-title">Shipping & Returns</h2>

        {/* content */}
        {returns.trim() !== "" ? (
          <div className="sidepage-content" dangerouslySetInnerHTML={{ __html: returns }} />
        ) : null}
      </main>

      <Footer theme={themeData} />
    </AppContainer>
  );
};

export default Returns;
